import { Typography, Form, Input } from 'antd';
import { inputItem } from './styles';

const { Text } = Typography;

export default function NewPasswordFields({
  name = 'password',
  label = 'Κωδικός',
  confirmLabel = 'Επιβεβαίωση Κωδικού',
  requiredMessage = 'Παρακαλώ εισάγετε κωδικό',
  confirmRequiredMessage = 'Παρακαλώ επιβεβαιώστε τον κωδικό'
}) {
  return (
    <>
      <Form.Item
        label={<Text strong>{label}</Text>}
        name={name}
        rules={[
          { required: true, message: requiredMessage },
          {
            pattern: /^(?=.*[A-Za-z])\S{5,}$/,
            message:
              'Ο κωδικός πρέπει να έχει τουλάχιστον 5 χαρακτήρες, να περιλαμβάνει τουλάχιστον 1 γράμμα και να μην περιλαμβάνει κενά'
          }
        ]}
      >
        <Input.Password size="large" style={inputItem} />
      </Form.Item>
      <Form.Item
        label={<Text strong>{confirmLabel}</Text>}
        name="confirmPassword"
        dependencies={[name]}
        rules={[
          { required: true, message: confirmRequiredMessage },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue(name) === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error('Ο κωδικός και η επιβεβαίωση κωδικού δεν ταυτίζονται')
              );
            }
          })
        ]}
      >
        <Input.Password size="large" style={inputItem} />
      </Form.Item>
    </>
  );
}
